$(document).ready(function(){
     $(".banner-container .owl-carousel").owlCarousel({
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        nav: false,
        items:1,
        loop: true,
        // navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        navText: ["<img src='https://cdn.shopify.com/s/files/1/0587/2150/1393/files/previous.png?v=1627017281'>","<img src='https://cdn.shopify.com/s/files/1/0587/2150/1393/files/next.png?v=1627017281'>"],
        smartSpeed: 900,
        margin: 0,
        dots: true,
        responsive:{
            1200:{
                nav: true
            }
        }
    });

     $(".deals-slider .owl-carousel").owlCarousel({
        autoplay: false,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        nav: false,
        items:1,
        loop: true,
        navText: ["<img src='https://cdn.shopify.com/s/files/1/0587/2150/1393/files/deal-left.png?v=1627017281'>","<img src='https://cdn.shopify.com/s/files/1/0587/2150/1393/files/deal-right.png?v=1627017281'>"],
        smartSpeed: 900,
        margin: 0,
        dots: true,
        responsive:{
            1250:{
                nav: true,
                dots: false,
            }
        }
    });

    $(".testimonials-slider .owl-carousel").owlCarousel({
        autoplay: true,
        autoplayTimeout: 10000,
        autoplayHoverPause: true,
        nav: true,
        items:1,
        loop: true,
        navText: ["<img src='https://cdn.shopify.com/s/files/1/0587/2150/1393/files/client-left.png?v=1627017281'>","<img src='https://cdn.shopify.com/s/files/1/0587/2150/1393/files/client-right.png?v=1627017281'>"],
        smartSpeed: 1000,
        margin: 20,
        dots: false,
        responsive:{
        0:{
            items:1,            
        },
        320:{
            items:1,
            nav: false,
            dots: true,
            
        },
        767:{
            items:2,
        },
        1200:{
            items:3
        }
    }
    });

    $('.banner .owl-dots').wrap('<div class="container"></div>');
  	$('.search-toggle').on('click',function() {
    	$(".search-box-wrapper").toggleClass("active")
        $("#boost-pfs-search-box-1").focus()
  	})
    $("#ContactFooter").validate({
			rules: {
				"contact[email]": {
					required: true,
					email: true
				}
			},
			messages: {
				"contact[email]": "",
			},
      		errorClass: "has-error",
		});
  
});

/*
 * Product "Configuration" build-sheet.
 * 1) Rewrites the spec table into single combined lines (CPU / RAM / PSU
 *    merged) in a logical build order, keeping the labels on the side.
 * 2) Makes "Copy Config" paste a clean list: one component per line, with the
 *    side labels and any prices removed.
 * Works for every server model from one place and survives the broken inline
 * copy scripts in some product templates.
 */
(function () {
  function cellText(node) {
    return node ? (node.textContent || "").replace(/\s+/g, " ").trim() : "";
  }
  function rowLabel(tr) {
    return cellText(tr.querySelector("th")).toLowerCase();
  }
  function rowValue(tr) {
    if (!tr) { return ""; }
    return cellText(tr.querySelector("td"));
  }

  function formatRamLine(ram, rate) {
    if (!ram) { return ""; }
    ram = ram.replace(/\s+/g, " ").trim();
    ram = ram.replace(/(\d+(?:\.\d+)?)\s*(GB|TB)\b/gi, function (_, num, unit) {
      return num + unit.toUpperCase();
    });
    if (!/RAM/i.test(ram)) { ram = ram + " RAM"; }
    if (rate) { ram = ram + " - " + rate; }
    return ram;
  }

  function formatPsuLine(count) {
    if (!count) { return ""; }
    return count.replace(/\s+/g, " ").trim() + " PSUS";
  }

  function buildConfigSheet() {
    var table = document.querySelector(".product-details-configuration-table");
    if (!table || table.dataset.ssBuilt) { return; }

    var body = table.tBodies[0] || table;
    var rows = Array.prototype.slice.call(table.querySelectorAll("tr"));
    var map = {};
    rows.forEach(function (tr) {
      var l = rowLabel(tr);
      if (l && !map[l]) { map[l] = tr; }
    });

    // --- Merge CPU rows into one line ---
    if (map["cpu"]) {
      var count = rowValue(map["cpus"]);
      var model = rowValue(map["cpu"]);
      var clock = rowValue(map["clock speed"]).replace(/\s*GHz/i, "GHz");
      var cores = rowValue(map["cores"]);
      var threads = rowValue(map["threads"]);
      if (model) {
        var head = count ? count + " \u00d7 " + model : model;
        var tail = [];
        if (clock) { tail.push(clock); }
        if (cores && threads) { tail.push(cores + "C/" + threads + "T"); }
        else if (cores) { tail.push(cores + "C"); }
        var cpuLine = head + (tail.length ? " - " + tail.join(" ") : "") + " CPU";
        map["cpu"].querySelector("th").innerHTML = "<b>CPU</b>";
        map["cpu"].querySelector("td").textContent = cpuLine;
      }
      ["cpus", "clock speed", "cores", "threads", "cache"].forEach(function (k) {
        if (map[k] && map[k].parentNode) { map[k].parentNode.removeChild(map[k]); }
        delete map[k];
      });
    }

    // --- RAM: e.g. "128 GB" -> "128GB RAM" ---
    if (map["ram"]) {
      var ram = formatRamLine(rowValue(map["ram"]), rowValue(map["transfer rate"]));
      if (ram) { map["ram"].querySelector("td").textContent = ram; }
      if (map["transfer rate"] && map["transfer rate"].parentNode) {
        map["transfer rate"].parentNode.removeChild(map["transfer rate"]);
        delete map["transfer rate"];
      }
    }

    // --- PSUs: e.g. "2" -> "2 PSUS" ---
    if (map["psus"]) {
      var psuCount = rowValue(map["psus"]);
      var psuLine = formatPsuLine(psuCount);
      if (psuLine) {
        map["psus"].querySelector("th").innerHTML = "<b>PSU</b>";
        map["psus"].querySelector("td").textContent = psuLine;
      }
      if (map["psu power"] && map["psu power"].parentNode) {
        map["psu power"].parentNode.removeChild(map["psu power"]);
        delete map["psu power"];
      }
      map["psu"] = map["psus"];
      delete map["psus"];
    }

    // --- Reorder into a logical build sheet ---
    var order = [
      "backplane", "nodes", "blades", "compute nodes", "storage nodes",
      "cpu", "gpu", "memory size", "ram", "boss", "storage",
      "raid controller", "nic", "ports", "software", "accessories",
      "psu", "psus", "psu power", "warranty"
    ];
    var current = Array.prototype.slice.call(table.querySelectorAll("tr"));
    current.sort(function (a, b) {
      var ia = order.indexOf(rowLabel(a));
      var ib = order.indexOf(rowLabel(b));
      if (ia === -1) { ia = 999; }
      if (ib === -1) { ib = 999; }
      return ia - ib;
    });
    current.forEach(function (tr) { body.appendChild(tr); });

    table.dataset.ssBuilt = "1";
  }

  function copyConfig(e) {
    if (e && e.preventDefault) { e.preventDefault(); }
    if (e && e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
    if (copyConfig._last && Date.now() - copyConfig._last < 400) { return; }
    copyConfig._last = Date.now();

    var table = document.querySelector(".product-details-configuration-table");
    if (!table) { return; }

    try { buildConfigSheet(); } catch (err) { /* format what we can, still copy */ }

    var lines = [];
    Array.prototype.forEach.call(table.querySelectorAll("tr"), function (tr) {
      var cells = tr.querySelectorAll("td");
      if (!cells.length) { return; }
      Array.prototype.forEach.call(cells, function (td) {
        (td.innerText || "").split(/\r?\n/).forEach(function (seg) {
          var txt = seg
            .replace(/[£$€]\s?[\d.,]+/g, "") // drop prices
            .replace(/\s+/g, " ")
            .trim();
          if (txt) { lines.push(txt); }
        });
      });
    });

    var plain = lines.join("\n");
    var html = lines.map(function (l) {
      return l.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }).join("<br>");

    if (navigator.clipboard && window.ClipboardItem) {
      navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([plain], { type: "text/plain" })
        })
      ]).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(plain).catch(function () {});
    }

    var btn = document.getElementById("product-details-configuration-copy-button");
    var svg = document.getElementById("product-details-configuration-copy-button-svg");
    var label = document.getElementById("product-details-configuration-copy-button-text");
    if (btn) {
      if (svg) { svg.style.fill = "#FFF"; }
      btn.style.background = "#4CA419";
      btn.style.color = "#FFF";
      btn.style.border = "0.25rem solid #4CA419";
      if (label) { label.innerText = "Config Copied"; }
      setTimeout(function () {
        if (svg) { svg.style.fill = ""; }
        btn.style.background = "";
        btn.style.color = "";
        btn.style.border = "";
        if (label) { label.innerText = "Copy Config"; }
      }, 3000);
    }
  }

  // Expose for the inline templates that call copyTable(...) directly.
  window.copyTable = function (el, e) { copyConfig(e); };

  $(document).ready(function () {
    window.copyTable = function (el, e) { copyConfig(e); };
    try { buildConfigSheet(); } catch (err) { /* keep copy working if one row is missing */ }
    document.addEventListener("click", function (e) {
      if (!e.target.closest("#product-details-configuration-copy-button")) { return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      copyConfig(e);
    }, true);
  });
})();